import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AcademicYear } from "./routes";

export default store => ({
  path: "grading-periods",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-grading-periods" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [AcademicYear(store)],
});
